export default "__VITE_ASSET__dcbf7983__"